import { IWizTranslatable } from '../../interfaces/iwiz-translatable';
import { WizTranslationObj } from '@wizeoo/akm-core-lib';

/** Component/Translation link obj class */
export class WizComponentTranslationObj {

  /** Translation key */
  public translationKey: string;

  /** Component UID  */
  private _parentUID: string;

  public get parentUID(): string {
    return this._parentUID;
  }

  /** Component class name */
  private _parentClassName: string;

  public get parentClassName(): string {
    return this._parentClassName;
  }

  /** Component's property */
  private _property: string;

  public get property(): string {
    return this._property;
  }

  /** Key for view usage */
  private _viewKey: string;

  public get viewKey(): string {
    return this._viewKey;
  }

  private _labelProperty: string;

  /**
   * The property in the component used to the key value. Helps us detectChanges on this property and load the translation
   */
  public get labelProperty(): string {
    return this._labelProperty;
  }

  /** Translation to be applied to the component's property */
  public translation: WizTranslationObj;

  /**
   * Constructor
   * @param pParent Translatable component
   * @param pTranslationKey Translation key
   * @param pProperty Component's property concerned
   */
  constructor(pParent: IWizTranslatable, pTranslationKey: string, pProperty: string,
              pLabelProperty: string = 'wizLabel', pViewKey?: string) {
    this.translationKey = pTranslationKey;
    this._parentUID = pParent.entityUID;
    //TODO JRO console.log('WARN CONSTRUCTOR', pParent.constructor.name );
    this._parentClassName = pParent.constructor.name;
    this._labelProperty = pLabelProperty;
    this._property = pProperty;
    if (pViewKey) {
      this._viewKey = pViewKey;
    }
  }
}
